import { isLocalDevHostname, normalizeVidhyantraDomain } from '@/utils/cookie-domain.util'
import { isStagingDeployHostname, STAGING_BASE_DOMAIN } from '@/utils/staging-domain.util'

export const PRODUCTION_BASE_DOMAIN = 'vidhyantra.com'

/**
 * Resolve deployed apex domain from the live hostname.
 * Ignores stale VITE_BASE_DOMAIN bake (e.g. vidyantra-dev.com on staging hosts).
 */
export function resolveDeployBaseDomainFromHostname(hostname?: string): string | null {
  const host = normalizeVidhyantraDomain(
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')
  ).toLowerCase()

  if (!host || isLocalDevHostname(host)) {
    return null
  }

  if (isStagingDeployHostname(host)) {
    return STAGING_BASE_DOMAIN
  }

  if (host === PRODUCTION_BASE_DOMAIN || host.endsWith(`.${PRODUCTION_BASE_DOMAIN}`)) {
    return PRODUCTION_BASE_DOMAIN
  }

  return null
}
